import React, { FC } from 'react';
import { Pagination, Stack } from '@mui/material';
import styles from './select-page.module.scss';
import { Navigate } from '../../constants';

interface SelectPageProps {
  page: number;
  onPageNavigate: (navigation: Navigate) => void;
  onPaginationClick: (page: number) => void;
}

export const SelectPage: FC<SelectPageProps> = ({ onPageNavigate, page, onPaginationClick }) => {
  return (
    <div className={styles.wrapper}>
      <Stack spacing={2}>
        <Pagination count={30} page={page + 1} onChange={(_, num) => onPaginationClick(num - 1)} />
      </Stack>
    </div>
  );
};
